import defaults from 'lodash/defaults'
import domready from 'domready'
import { throttle } from 'throttle-debounce'

export default class PageScrolledController {
  constructor (options) {
    this._settings = defaults(options, {
      scrolledClass: 'page--scrolled',
      tolerance: 0
    })

    this._lastScrolled = null

    this._bindUIActions()
  }

  _updateScrolledStatus () {
    var scrolledPx = window.scrollY
    const scrolled = scrolledPx > this._settings.tolerance
    if (scrolled !== this._lastScrolled) {
      this._lastScrolled = scrolled
      if (scrolled) {
        document.body.classList.add(this._settings.scrolledClass)
      } else {
        document.body.classList.remove(this._settings.scrolledClass)
      }
    }
  }

  _bindUIActions () {
    domready(() => {
      this._updateScrolledStatus()
    })
    const updateThrottled = throttle(100, () => {
      this._updateScrolledStatus()
    })
    window.addEventListener('scroll', updateThrottled)
  }
}
